import { isStudent } from '../utils';

export const buildFinalHighlightsProps = (block, state, authState) => {

    const { props } = block;

    const buildProps = () => {

        let title = props.title?.default ?? null;
        let text = props.text?.default ?? null;
        let video = props?.video
        let img = props.img?.default ? { ...props.img?.default, src: props.img?.default?.src } : null;

        if (isStudent(state)) {
            title = props.title?.student ?? props.title?.default ?? null;
            text = props.text?.student ?? props.text?.default ?? null;
        }

        return {
            title,
            text,
            video,
            img
        };
    };

    const resolvedProps = buildProps();

    return {
        id: block.id,
        type: block.type,
        props: resolvedProps,
    };
};

